import { getServiceCatalog } from "@/library/http";

export const getEnums = (name: string) => getServiceCatalog(`/public/infra-service/enum/${name}`);
